import { Game } from '@/constants/game.const';

/** Extracts the game prefix (e.g. "dota" or "cs2") if present in the path. */
export function extractGamePrefixFromPath(pathname: string): Game | null {
  const parts = pathname.split('/');
  if (parts.length > 1 && isGameEnum(parts[1])) {
    return parts[1];
  }
  return null;
}

function isGameEnum(value: string): value is Game {
  return Object.values(Game).includes(value as Game);
}
